import React, {useEffect, useState} from 'react';
import {Col, Modal, notification, Row, Spin, Button} from "antd";
import '../modals.css';
import {approveOrderService} from "../../../services/approve-order.service";
import {fileHelper} from "../../../helpers/file.helper";
import i18n from "i18next";

export default function ModalShowEdoContractFiles({isShow, setIsShow, id}) {

  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState({});

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };

  useEffect(() => {
    setLoading(true);
    if (id && isShow) {
      approveOrderService
        .getDocsListOnEdoContracts(id)
        .then(resp => {
          setInfo(resp);
          setLoading(false);
        })
        .catch(errMsg => notification.error(
          {
            message: i18n.t('components.notification.titles.getContractsListOnUpload2'),
            description: errMsg
          }));
    }
  }, [id, isShow]);

  const handleDownloadDoc = fileUrl => {
    window.open(fileUrl);
  };

  const handleGoToLink = link => {
      window.open(link, '_blank', 'noopener,noreferrer');
  }

  const handleDownloadDocsArchive = (id) => {
    approveOrderService.getDownloadContractOrderFiles(id)
      .then(resp => {
        fileHelper.downloadFileBase64(resp, 'contracts.zip')
      })
      .catch(err => {
        notification.error({
          message: i18n.t('components.notification.titles.getLegalEntityDocsArchive'),
          description: err
        });
      });
  };

  const renderButtonsDownload = info => {
    let buttons = [];

    Object.keys(info).forEach(value => {
      value = info[value];

      if(!(value.uploadedFile || value.blankFile)) {
        return;
      }

      buttons.push(
        <>
          <Button style={{marginLeft: "0px", width: "100%"}} onClick={() => handleDownloadDoc(value.blankFile)}
                  size="small" className="small-button typical-btn-blue">
            {i18n.t('main.buttons.downloadOriginal')} "{value.alias}"
          </Button>
          {value.edoDoc != null && Object.keys(value.edoDoc.shipperLinks).map((key) => {
              return (<>
                  <Button style={{marginLeft: "0px", width: "100%"}} onClick={() => handleGoToLink(value.edoDoc.shipperLinks[key])}
                    size="small" className="small-button typical-btn-blue">
                      {i18n.t('components.tools.logistShortButton.buttons.edoDoc.' + value.edoDoc.status)} "{value.alias}"
                  </Button>
              </>)
          })}
        </>
      );
    });

    return (
      <>
        {buttons}
      </>
    );
  };

  let buttons = renderButtonsDownload(info);

  return (
    <Modal
      title={<span className="ant-modal-title">{i18n.t('modals.modalShowContractFiles.title')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={<Row>
        <Col offset={8} span={8}>
          <Button
            htmlType="button"
            key="submitPrev"
            onClick={() => setIsShow(false)}
            type="primary"
            size="large"
            style={{width: '100%'}}
          >
            {i18n.t('main.buttons.close')}
          </Button>
        </Col>
      </Row>}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row type="flex" justify="center">
          <Col lg={8} md={24} sm={24} xs={24}>
            {buttons}
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
}
